import { render, staticRenderFns } from "./BackendManage.vue?vue&type=template&id=5d88ba9c&scoped=true"
import script from "./BackendManage.vue?vue&type=script&lang=js"
export * from "./BackendManage.vue?vue&type=script&lang=js"
import style0 from "./BackendManage.vue?vue&type=style&index=0&id=5d88ba9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d88ba9c",
  null
  
)

export default component.exports